import mapFunction from './mapResources';

export default mapFunction('operations_employees_list', {
    isFetching: false,
    items: []
});